import script from "./ProtectedAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProtectedAvatar.vue?vue&type=script&setup=true&lang=ts"

import "./ProtectedAvatar.vue?vue&type=style&index=0&id=8f43cade&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f43cade"]])

export default __exports__